import React, { Component } from 'react'


class TeamMember extends Component {

  render() {
    const data = this.props;

    return (
      <>
        <section className="team-member">
          <div className="team-member__inner container">
            <div className="team-member__inner--left">
              <h6>{data.name}</h6>
              <ul>
                <li><img src={data.bullet.url} alt="WhiteFox"/><p>{data.phone}</p></li>
                <li><img src={data.bullet.url} alt="WhiteFox"/><p>{data.email}</p></li>
              </ul>
              <p className="paragraph" dangerouslySetInnerHTML={{ __html: data.content }}/>
            </div>
            <div className="team-member__inner--right">
              <img src={data.agent.url} alt="WhiteFox"/>
            </div>
          </div>
        </section>
      </>
    )
  }
}

export default TeamMember
